<template>
    <div>
        <v-row align="center" class="mb-4">
            <v-col :cols="3">
                <date-picker
                    v-model="dateData"
                    :label="$t('date')"
                    :clearable="false"
                    density="compact"
                    outlined
                    hide-details
                />
            </v-col>
            <v-col :cols="2">
                <v-select
                    v-model="selectedCurrency"
                    :loading="isLoading"
                    :disabled="isLoading"
                    :items="currencyList"
                    density="compact"
                    hide-details
                />
            </v-col>
            <v-col>
                <v-btn color="primary" class="mr-4" @click="resetFilters">{{ t('reset') }}</v-btn>
                <v-btn :loading="isLoading" :disabled="isLoading" color="primary" @click="load">
                    {{ t('search') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-data-table
            :headers="headers"
            :items="items"
            :loading="isLoading"
            color="primary"
            density="compact"
            hide-default-footer
            style="max-width: 500px"
            class="elevation-1"
        />
        <div v-if="currencyRatesFrom" class="pt-4">
            {{ t('currency_exchange_rates_come_from') }}
            <a :href="currencyRatesFrom" target="_blank">{{ currencyRatesFrom }}</a>
        </div>
    </div>
</template>

<script setup lang="ts">
    import DatePicker from '@/components/snippets/forms/DatePicker.vue'
    import {format} from 'date-fns'

    const app = useNuxtApp()
    const conf = useRuntimeConfig()
    const {t} = useI18n()

    const headers: ComputedRef<{title: string; value: string}[]> = computed(() => {
        return [
            {title: t('currency'), value: 'currency'},
            {title: t('exchange_rate'), value: 'exchangeRates'},
        ]
    })
    const currencyList: ComputedRef<any[]> = computed(() =>
        Object.values(conf.public.currency.available).filter(currency =>
            Object.keys(runtimeStore.exchangeRates).includes(currency)
        )
    )
    const currencyRatesFrom: ComputedRef<string> = computed(() => runtimeStore.CRMSettings?.currencyRatesFrom || '')

    const isLoading = ref<boolean>(false)
    const selectedCurrency = ref<string>(conf.public.currency.default)
    const dateData = ref<string>(format(new Date(), 'yyyy-MM-dd'))
    const items = ref<any[]>([])

    onMounted(() => {
        load()
    })

    function resetFilters(): void {
        dateData.value = format(new Date(), 'yyyy-MM-dd')
        selectedCurrency.value = conf.public.currency.default
        load()
    }

    async function load(): Promise<void> {
        try {
            isLoading.value = true
            const res = await app.$api.exchangeRates.get({currencyCode: selectedCurrency.value, date: dateData.value})
            const list = []

            for (const key in res) {
                list.push({currency: key, exchangeRates: res[key]})
            }
            items.value = list
        } catch (e) {
            console.error(e)
        } finally {
            isLoading.value = false
        }
    }
</script>
